import { createFileRoute } from "@tanstack/react-router";
import { HomeScreen } from "@/features/night/home/HomeScreen";

export const Route = createFileRoute("/_authenticated/")({
  component: HomePage,
});

/**
 * League home. Renders the night-theme redesign (see `HomeScreen`). The prior
 * light dashboard (`LeagueOverview`, onboarding) is preserved in the codebase
 * and will be re-wired into the night layout as the migration continues.
 */
function HomePage() {
  return <HomeScreen />;
}
